import { createFileRoute } from '@tanstack/react-router';
import { CampaignManage } from '@/features/campaigns/campaign-dashboard';

export const Route = createFileRoute('/_authenticated/campaigns/$id/manage')({
    head: () => ({ meta: [{ title: 'Manage Campaign | promote.fun' }] }),
    component: CampaignManage,
});
